const LOG_LEVELS = ["debug", "info", "warn", "error", "fatal"];
const DEFAULT_OPTIONS = {
	isEnabled: true,
	logLevel: "debug",
	separator: "|",
	showConsoleColors: true,
	showLogLevel: true,
	showMethodName: false,
	showFiledName: true,
	stringifyArguments: false
};

function getMethodName() {
	let error = {};

	try {
		throw new Error("");
	} catch (e) {
		error = e;
	}

	if (error.stack === undefined) {
		return "";
	}

	let stackTrace = error.stack.split("\n")[3];
	if (/ /.test(stackTrace)) {
		stackTrace = stackTrace.trim().split(" ")[1];
	}
	if (stackTrace && stackTrace.indexOf(".") > -1) {
		stackTrace = stackTrace.split(".")[1];
	}
	return stackTrace;
}

function getFileName() {
	let error = {};
	const STACK_FUNC_NAME = /at\s+((\S+)\s)?\((\S+):(\d+):(\d+)\)/;

	try {
		throw new Error("");
	} catch (e) {
		error = e;
	}

	if (error.stack === undefined) {
		return { val: "" };
	}

	const stacks = error.stack.split("\n");
	const callerInfo = STACK_FUNC_NAME.exec(stacks[3]);

	if (callerInfo) {
		return {
			filename: callerInfo[3],
			line: callerInfo[4],
			column: callerInfo[5],
			val: `${callerInfo[3]}:${callerInfo[4]}:${callerInfo[5]}`
		};
	}

	return { val: "" };
}

function printLogMessage(
	logLevel = "warn",
	logMessage = "",
	showConsoleColors = false,
	formattedArguments = []
) {
	if (
		showConsoleColors &&
		(logLevel === "warn" || logLevel === "error" || logLevel === "fatal")
	) {
		const debugLogLevel = logLevel === "debug" ? "trace" : logLevel;
		console[logLevel === "fatal" ? "error" : debugLogLevel](
			logMessage,
			...formattedArguments
		);
	} else {
		console.trace(logMessage, ...formattedArguments);
	}
}

function initLoggerInstance(options, logLevels) {
	const logger = {};

	logLevels.forEach((logLevel) => {
		if (
			options.isEnabled &&
			logLevels.indexOf(logLevel) >= logLevels.indexOf(options.logLevel)
		) {
			logger[logLevel] = (...args) => {
				const fileName = getFileName();
				const filePrefix = options.showFiledName
					? `${fileName.val} ${options.separator} `
					: "";

				const methodName = getMethodName();
				const methodNamePrefix = options.showMethodName
					? `${methodName} ${options.separator} `
					: "";
				const logLevelPrefix = options.showLogLevel
					? `${logLevel} ${options.separator} `
					: "";
				const formattedArguments = options.stringifyArguments
					? args.map((a) => JSON.stringify(a))
					: args;
				const logMessage = `${logLevelPrefix}  ${filePrefix} ${methodNamePrefix}`;
				printLogMessage(
					logLevel,
					logMessage,
					options.showConsoleColors,
					formattedArguments
				);
				return `${logMessage} ${formattedArguments.toString()}`;
			};
		} else {
			logger[logLevel] = () => {};
		}
	});
	return logger;
}

export const $log = initLoggerInstance(DEFAULT_OPTIONS, LOG_LEVELS);

export function useLogger() {
	return LOG_LEVELS.reduce(
		(acc, curr) => {
			acc[curr] = $log[curr];
			return acc;
		},
		{
			warn: (..._args) => {},
			error: (..._args) => {},
			fatal: (..._args) => {},
			debug: (..._args) => {},
			trace: (..._args) => {}
		}
	);
}

export default {
	install(app, options = {}) {
		const loggerInstance = initLoggerInstance(
			{ ...DEFAULT_OPTIONS, ...options },
			LOG_LEVELS
		);
		app.$log = loggerInstance;
		app.config.globalProperties.$log = loggerInstance;
	}
};
